export default function EmptyState({
    icon,
    title,
    description,
    action = null,
    className = '',
}) {
    return (
        <div className={`empty-state ${className}`.trim()}>
            {icon ? <div className="empty-state-icon">{icon}</div> : null}
            <h3 className="empty-state-title">{title}</h3>
            {description ? <p className="empty-state-text">{description}</p> : null}
            {action}
        </div>
    )
}
